import { datadogRum } from '@datadog/browser-rum-slim';
import ConfigService from 'client/util/ConfigService';
import every from 'lodash/every';
import identity from 'lodash/identity';

const appVersion = process.env.VUE_APP_VERSION || '0.0.0';

export default {
  initialize(params = {}) {
    const { serviceName } = params;
    const applicationId = ConfigService.ddAppId;
    const clientToken = ConfigService.ddClientId;
    const sessionSampleRate = ConfigService.ddSampleRate || 50;
    const version = appVersion;

    // If any of the config params are missing, don't load DataDog
    // This is considered a misconfiguration and is unexpected
    const areAllParamsAvailable = every([
      applicationId,
      clientToken,
      serviceName,
    ], identity);

    return areAllParamsAvailable && datadogRum.init({
      applicationId,
      clientToken,
      sessionSampleRate,
      site: 'datadoghq.com',
      service: serviceName,
      version,
      // session replay is not available for the slim package
      // replaySampleRate: 0,
      // the following control premium features that are not included in our plan
      // please ping #ask-reliability before using
      trackInteractions: false,
      trackLongTasks: false,
      trackResources: false,
    });
  },
};
